import { render, staticRenderFns } from "./SellerButtons.vue?vue&type=template&id=6553e0a2&scoped=true&"
import script from "./SellerButtons.vue?vue&type=script&lang=ts&"
export * from "./SellerButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SellerButtons.vue?vue&type=style&index=0&id=6553e0a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6553e0a2",
  null
  
)

export default component.exports